import "swiper/css/pagination";
import { PriceTableContent, RowContent } from "constants/prices";

import { useContext, useState } from "react";

import { Typography, Divider } from "antd";
import { AppContext } from "App";
import purpleCheck from "assets/images/check_purple.svg";
import pricingCheckmark1 from "assets/images/green_check.svg";
import greyRadio from "assets/images/grey_radio.svg";
import pricingCross from "assets/images/pricing-cross.svg";
import StartButtonPricing from "components/basic/StartButtonPricing";
import { DiscountBox } from "components/pages/Questionnaire/components/Payment/components/DiscountBox";
import { useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";

/* eslint-disable no-unused-vars */
const PriceTableRow = ({ text, showCheck }: RowContent) => {
    const image = showCheck ? pricingCheckmark1 : pricingCross;
    return <div className="vertical-center gap8">
        <img src={image} alt="checkmark or cross" width={"20px"}/>
        <Typography>{text}</Typography>
    </div>;
};
function getPriceClass({
    isSelected,
    isDiscounted,
    isNotPaywall,
    amount,
    originalPrice,
}: {
  isSelected: boolean | undefined;
  isDiscounted: boolean;
  isNotPaywall: boolean | undefined;
  amount: number | undefined;
  originalPrice: string;
}): string {
    const parsedOriginal = parseFloat(originalPrice);

    if (
        isSelected &&
    isDiscounted &&
    isNotPaywall &&
    amount !== undefined &&
    amount !== parsedOriginal
    ) {
        return "price-tables__old-price";
    }

    return isNotPaywall
        ? "price-tables__price"
        : "price-tables__price-mobile";
}

export const PriceCard = ({ isSelected, onSelect, category, title, originalPrice, rows, popular, isPaymentMode, amount, setAmount, className, isActive, isNotPaywall, description }: PriceTableContent) => {
    const { isMobile } = useContext(AppContext);
    const { currentDocument } = useAppSelector(
        (state: RootState) => ({
            currentDocument: state.document.currentDocument,
        })
    );
    const [, setOriginalPrice] = useState<number>(0);
    const isDiscounted = originalPrice !== undefined && parseFloat(originalPrice) !== amount;
    const showCheckmark = isPaymentMode && (
        (isMobile && isActive) || (!isMobile && isSelected)
    );
    const showGreyRadio = !showCheckmark && isPaymentMode;
    return (
        <div onClick={onSelect} className="price-tables__card-container">
            <div className={
                isMobile
                    ? className
                    : ((isPaymentMode && isSelected) || (!isPaymentMode && popular))
                        ? "price-tables__card-purple"
                        : "price-tables__card"
            }>
                <div className={isPaymentMode ? "price-tables__container-paywall" : "price-tables__container"}>
                    <div
                        className={
                            isNotPaywall
                                ? `mb10 ${
                                    popular
                                        ? "space-between"
                                        : "horizontal-right price-tables__card-header"
                                }`
                                : ""
                        }
                    >
                        {popular && (
                            <div className={isNotPaywall ? "price-tables__banner" : "price-tables__banner-mobile"}>
                                {popular}
                            </div>
                        )}
                        {showCheckmark && (
                            <div className={isNotPaywall ? "price-tables__checkmark" : " price-tables__checkmark-mobile"}>
                                <img src={purpleCheck} alt="purple checkmark" />
                            </div>
                        )}
                        {showGreyRadio && (
                            <div className={isNotPaywall ? "price-tables__grey-radio" : " price-tables__grey-radio-mobile"}>
                                <img src={greyRadio} alt="grey radio" />
                            </div>
                        )}
                    </div>
                    <Typography className={isNotPaywall ? "price-tables__category" : "price-tables__category-mobile"}>
                        {category}
                    </Typography>

                    {isNotPaywall && (
                        <Typography className="price-tables__title">{title}</Typography>
                    )}

                    <div>
                        {category !== "Reviewed Return" && <span
                            className={isNotPaywall ? "price-tables__small-text" : "price-tables__small-text-mobile"}
                        >
                            {isMobile ? "only " : ""}
                        </span>}

                        <span
                            className={getPriceClass({
                                isSelected,
                                isDiscounted,
                                isNotPaywall,
                                amount,
                                originalPrice,
                            })}
                        >
                            £{originalPrice} {" "}
                        </span>
                        <span className={"price-tables__grey-text"}>
                            {description}
                        </span>
                    </div>

                    {isSelected && isDiscounted && isNotPaywall && (amount !== undefined && amount !== parseFloat(originalPrice)) && (
                        <div>
                            <span className={isNotPaywall ? "price-tables__small-text" : "price-tables__small-text-mobile"}>only{" "}</span><span className={isNotPaywall ? "price-tables__price" : "price-tables__small-text-mobile"}>
                            £{amount?.toFixed(2)}
                            </span>
                        </div>
                    )}
                    <div onClick={e => e.stopPropagation()}>
                        {isPaymentMode && isNotPaywall && <DiscountBox
                            setAmount={setAmount ?? (() => {})}
                            setOldAmount={setOriginalPrice}
                            amount={amount ?? 0}
                            documentId={currentDocument._id}
                        />}
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "16px", maxWidth: "320px" }}>
                    {rows.map((row, index) => (
                        <div key={index}>
                            <PriceTableRow text={row.text} showCheck={row.showCheck} />
                            <Divider className="price-tables__rows" />
                        </div>
                    ))}
                </div>

                {isNotPaywall && (
                    !isPaymentMode ? (
                        <StartButtonPricing authLabel="Continue" label="Get Started" className={popular ? "shared__primary-button w100" : "shared__secondary-button w100"} />
                    ) : (
                        isSelected ? (
                            <button
                                className={"shared__primary-button w100"}
                                onClick={onSelect}
                            >
                            Pay Now
                            </button>
                        ) : (
                            <button
                                className={"shared__secondary-button w100"}
                                onClick={onSelect}
                            >
                            Select & Pay Now
                            </button>
                        )
                    )
                )}
            </div>
        </div>
    );
};
